//
//
//
//
//
//
//
//
//
//
//
//
//

import {prefix} from '../../common/mixins'

export default {
  name: 'Wrapper',
  mixins: [prefix],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    noMask: {
      type: Boolean,
      default: false,
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Dialog/Wrapper.vue